import React from 'react'

function LoadingSpinner({ size = 'medium', className = '' }) {
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-8 h-8',
    large: 'w-12 h-12'
  }

  return (
    <div className={`inline-block ${sizeClasses[size]} ${className}`}>
      <div className="animate-spin rounded-full border-4 border-solid border-primary-200 border-t-primary-600 h-full w-full"></div>
    </div>
  )
}

export default LoadingSpinner